/* eslint-disable max-len */

import { projectDomainName } from 'shared/constants'

import { localeCommonType } from '../en-US'

export const common: localeCommonType = {
  roulette: 'Ruleta',
  bonusWheel: 'Rueda de bonificación',
  spinHistory: 'Historial de giros',
  menu: 'Menú',
  profile: 'Perfil',
  noOptions: 'Sin opciones',
  betOnSport: 'Apuesta Pre-Partida',
  betOnLive: 'Apuesta en vivo',
  betOnSport1: 'Apuesta Pre-Partida 1',
  betOnSport2: 'Apuesta Pre-Partida 2',
  digitain: 'Digitain',
  betby: 'BetBy',
  softion: 'Softion',
  usernameOrEmail: 'Nombre de usuario',
  searchGamesOrProviders: 'Buscar juegos o proveedores',
  pleaseEnter: 'Ingrese un NÚMERO o más caracteres',
  checkBetHistory: 'Comprobar el Historial de Apuestas',
  pleaseAuth: 'Por favor, auth',
  liveGames: 'Juegos en vivo',
  save: 'Guardar',
  selectedItems: 'artículos seleccionados',
  selectAll: 'Seleccionar todo',
  expander: 'Expansor',
  parisSportif: 'Paris sportif',
  info: 'Información',
  mainBets: 'Apuesta principal',
  total: 'Total',
  line1: 'Línea 1',
  live1: 'En vivo 1',
  resetPasswordTokenNotProvided: 'No se proporcionó el token de restablecimiento de contraseña',
  line2: 'Línea 2',
  live2: 'En vivo 2',
  handicap: 'Discapacidad',
  toUseSport: 'Para usar el deporte, por favor auth',
  chooseSport: 'Elige deporte',
  sportBetting1: 'Apuestas deportivas 1',
  sportBetting2: 'Apuestas deportivas 2',
  sportBetting3: 'Apuestas deportivas 3',
  liveBetting1: 'Apuestas en vivo 1',
  liveBetting2: 'Apuestas en vivo 2',
  liveBetting3: 'Apuestas en vivo 3',
  betHistory1: 'Historial de apuestas 1',
  betHistory2: 'Historial de apuestas 2',
  doubleChance: 'Doble oportunidad',
  loading: 'Cargando',
  admin: 'Panel de administración',
  results: 'Resultados',
  search: 'Buscar',
  contacts: 'Contactos',
  partners: 'Socios',
  terms: 'Términos',
  termsConditions: 'Términos y Condiciones',
  yes: 'Sí',
  no: 'No',
  amount: 'Importe:',
  copy: 'Copiar',
  line: 'Línea',
  liveSport: 'Deporte en\u00A0vivo',
  live: 'Deporte en\u00A0vivo',
  sport: 'Deporte',
  sport1: 'Deporte 1',
  sport2: 'Deporte 2',
  sport3: 'Deporte 3',
  liveSport1: 'Digitain',
  liveSport2: 'BetBy',
  liveSport3: 'Softion',
  prematch: 'Prematch',
  soccer: 'Fútbol',
  iceHockey: 'Hockey sobre hielo',
  slots: 'Juegos',
  betOnCasino: 'Apuesta en Casino',
  casinoGames: 'Juegos de Casino',
  sportBetting: 'Apuestas deportivas',
  betgames: 'Juegos de apuestas',
  casinolive: 'Livecasino',
  language: 'Lenguaje',
  products: 'Productos',
  about: 'Acerca de',
  help: 'Ayuda',
  promotions: 'Promociones',

  footerText3: 'Todos los derechos reservados y protegidos por la ley Copyright © 2020 forzzaio',

  beResponsible: 'Sé responsable y sigue tus hábitos de juego!',
  upbutton: 'al principio',
  authorization: 'Iniciar sesión',
  registration: 'Registrarse',
  myBets: 'Mis apuestas',
  login: 'Iniciar sesión',
  topUp: 'Depósito',
  userInfo: 'Datos personales',
  withdrawal: 'Retirar dinero',
  betHistory: 'Historial de apuestas',
  slotsHistory: 'Historia de las tragamonedas',
  virtualGames: 'Juegos virtuales',
  newVirtuals: 'Nuevos virtuales',
  payHistory: 'Historial de operaciones',
  present: 'Bonificaciones',
  phone: 'Descargar solicitud',
  logout: 'Cerrar sesión',
  promotionalCodes: 'Activar código promocional',
  odd: 'Probabilidades',
  decimal: 'Decimal',
  american: 'Estadounidense',
  fractional: 'Fraccional',
  download: 'Descargar',
  mobileApplication: 'Aplicación móvil',
  oneClick: 'En 1 clic',
  main: 'Principal',
  home: 'Inicio',
  affiliate: 'Afiliado',
  topLeagues: 'Ligas superiores',
  upcomingEvents: 'Próximos eventos',
  favorite: 'Favorito',
  esport: 'Deportes electrónicos',
  casino: 'Casino',
  liveCasino: 'Casino en\u00A0vivo',
  basket: 'Boleta de apuestas',
  bonuses: 'Bonificaciones',
  downloadApp: 'Descargar aplicación',
  information: 'Información',
  settings: 'Configuración',
  accountSettings: 'Configuración de la cuenta',
  ticket: 'Billete',
  promocodes: 'Códigos promocionales',
  paymentMethods: 'Métodos de pago',
  aboutUs: 'Sobre nosotros',
  close: 'Cerrar',
  coef: 'Impar',
  quest: 'Sobre nosotros',
  cybersport: 'Ciberdeporte',
  totalizator: 'Totalizador',
  phoneCode: 'Verifique el código de finalización de su teléfono',
  submit: 'Cambiar contraseña',
  newPass: 'Ingrese una nueva contraseña',
  serve: 'Servir',
  continue: 'Guardar y continuar',
  enterLogin: 'Ingrese su teléfono o correo electrónico',
  confirmPass: 'Ingrese la contraseña nuevamente',
  feedbackPhone: 'Teléfono de retroalimentación',
  support: 'Apoyo',
  ourCashiers: 'Nuestra taquilla',
  ourSocials: 'Nuestras redes sociales',
  license: `PASSIONBET N.V.
  Registration number: 142633
  Abraham de Veerstraat 7, Willemstad, Curacao`,
  onСooperation: 'Sobre la cooperación',
  onlineChat: 'Chat en línea',
  aboutUsTitle: 'Sobre nosotros',
  emptyFullEvent: 'Este evento ha terminado',
  inDeveloping: 'En desarrollo',
  signIn: 'Iniciar sesión',
  send: 'Enviar',
  delete: 'Suprimir',
  sendUsFeedBack: 'Envíenos un formulario de comentarios',
  termsAndConditions: 'Términos y condiciones',
  resposibleGamingStatement: 'Declaración de juego responsable',
  privacyPolicy: 'Política de privacidad',
  todays: 'Hoy',
  revenueReport: 'Informe de Ingresos',
  accountList: 'Lista de cuentas',
  newUser: 'Nuevo usuario',
  transfers: 'Transferencias',
  bets: 'apuestas',
  sportsBetting: 'Apuestas deportivas',
  betSlip: 'Boleta de apuestas',
  liveBetting: 'Apuestas en vivo',
  myFavorites: 'Mis favoritos',
  recoveryPassword: 'Recuperación de contraseña',
  bc: 'Nueva Apuesta Deportiva',
  newPassword: 'Nueva contraseña',
  highlights: 'Aspectos destacados',
  mostPlayedEvents: 'Eventos más jugados',
  lastMinuteEvents: 'Eventos de última hora',
  today: 'Hoy',
  langSelection: 'Selección de idioma',

  typeSearchTerm: 'Escriba el término de búsqueda',

  siteName: 'Forzza N. V.',
  siteStreet: 'Parque de Comercio electrónico Heelsumstraat 51',
  siteCity: 'Willemstad',
  curacao: 'Curaçao',
  setLanguage: 'Establecer idioma',

  gamingHistory: 'Historial de juegos',
  logToPlaceBet: 'Para realizar apuestas, debe iniciar sesión',
  enableScrolling: 'Habilitar desplazamiento',
  disableScrolling: 'Deshabilitar el desplazamiento',
  balance: 'Equilibrio',
  bonusBalance: 'Saldo de bonificación',
  accountStatement: 'Estado de cuenta',
  company: 'Compañía',
  bettingRules: 'Reglas de apuestas',
  responsibleGaming: 'Juego responsable',

  username: 'Nombre de usuario',

  website: 'Sitio web',
  description: 'Descripción',
  id: 'Id',
  status: 'Estado',
  name: 'Nombre del sitio web',
  link: 'Url del sitio web',
  addWebsite: 'Agregar sitio web',

  changeWebsiteInfo: 'Cambiar Información del sitio Web',
  deleteWebsite: 'Eliminar sitio web',
  areYouWantDelete: '¿Quieres eliminar este sitio web?',

  dateJoined: 'Fecha de ingreso',
  balanceCurrency: 'Moneda de saldo',
  isBanned: 'Está prohibido',
  profitFromAgent: 'Beneficio Del Agente',

  contactsText: 'Si tienes alguna duda o problema, escríbenos a Facebook o Whatsapp',
  userData: 'Datos del usuario',
  crash: 'Accidente',
  evoAutoGames: 'Juegos de autos Evo',
  setOdds: 'Establecer probabilidades',
  sessionExpired: 'La sesión expiró!',
  sessionExpiredText: 'Su sesión ha caducado porque ha estado inactivo durante al menos 20 minutos en esta página',
  availableToWithdraw: 'Disponible para retirar',
  yesterday: 'Ayer',
  currentMonth: 'Mes actual',
  thirtyDays: '30 días',
  summaryStatistic: 'Estadística resumida',
  filter: 'Filtro',
  commision: 'Comisión',
  deposits: 'Depósitos',
  registrations: 'Registros',
  mainMenu: 'Menú principal',
  profilePage: 'Página de perfil',
  mainPage: 'Página principal',
  websites: 'Sitios web',
  marketingTools: 'Herramientas de marketing',
  promoCodes: 'Códigos promocionales',
  affiliateLinks: 'Enlaces de afiliados',
  childStatistic: 'Estadística infantil',
  reports: 'Informes',
  fullReport: 'Informe completo',
  playerReport: 'Informe del jugador',

  action: 'Acción',
  copied: 'Copiado!',

  ffindOut: 'Descubre más',
  ftext2: 'Si tiene algún problema con el sitio web, puede contactarnos usando esto',
  fform: 'formulario',
  brouchure: 'Brouchure',
  news: 'Noticias',
  cookiePolicy: 'Política de cookies',
  appAndroid: 'Aplicación para Android™',
  copyright: 'Copyright © 2007-2022 " Socios-1xBet". Todos los derechos reservados.',

  dateFrom: 'Fecha de',
  dateTo: 'Fecha hasta',

  depositsCount: 'Recuento de depósitos',
  depositsSum: 'Suma de depósitos',
  revenueShare: 'Participación en los ingresos',
  currency: 'Moneda',

  howItWorks: 'Cómo funciona',
  register: 'Registrarse',
  fastAndSimple: 'Rápido y fácil',
  topUpYouAccount: 'Recarga tu cuenta',
  haveFunWithBonuses: 'Diviértete con los bonos',
  play: 'Jugar',
  overThanGames: 'Más de 3500 juegos',
  fastPayouts: 'Pagos rápidos',
  getPayoutLessThan: 'Reciba su pago en menos de una hora',
  showMore: 'Mostrar más',
  meetBgonzo: '¡Conoce a BGonzo!',
  more: 'Más',
  meetGonzos: 'Conoce a Gonzos',
  learnMore: 'Más información',
  joinGonzos: 'ÚNETE A GONZOS Y JUEGA',
  // main mobile menu
  spin2win: 'Spin2Win',
  horseRacing: 'Carreras de caballos',
  bookingCode: 'Código de reserva',
  liveScore: 'Marcador en vivo',
  lotto: 'Lotería',
  wheel: 'Rueda de juego',
  virtuals: 'Virtuales',
  evolution: 'Evolución',
  roulettes: 'Ruletas',
  blackjack: 'Blackjack',

  privacy: 'Privacidad',
  amlProcedures: 'Procedimientos AML',
  faq: 'Preguntas frecuentes',
  sportRulesAndBettingOptions: 'Reglas Deportivas y Opciones de Apuestas',
  socialMedia: 'Redes sociales',
  tennis: 'Tenis',
  basketball: 'Baloncesto',
  hockey: 'Hockey',
  volleyball: 'Voleibol',

  footerText1: `Utilizamos cookies propias y de terceros para mejorar nuestros servicios,
  analizar y personalizar sus preferencias y mostrarle anuncios.
   Si continúa navegando, consideramos que acepta su uso.
   Puede cambiar la configuración y obtener más información en nuestra política de cookies.`,
  footerText2:
    'El pie de página predeterminado debe reemplazarse por un pie de página específico de la casa de apuestas.',

  footerWarning:
    'Atención! El juego puede ser adictivo. Lee las reglas y juega responsablemente.Las personas que no hayan cumplido los 18 años tienen prohibido participar en juegos de azar. Juega responsablemente.',

  footerLicense: `${projectDomainName.toUpperCase()} es operado por Black Dance B. V. (Registro comercial de Curaçao no. 158182, Emancipatie Boulevard Dominica F. " Don " Martina 31, Curaçao) bajo una sublicencia CIL de conformidad con la Licencia Maestra de juego #5536 / JAZ.`,
  footerDescription:
    'Las apuestas deportivas están asociadas con problemas de juego. Juega responsablemente. Como jugador, debes cumplir con las normas y leyes de las instituciones y autoridades gubernamentales de tu país. Forzza no puede, de ninguna manera, asumir responsabilidades por el uso ilícito o no autorizado de sus contenidos y servicios. Los menores de edad tienen prohibido participar en apuestas deportivas u otros juegos en este sitio web. Toda la información en este sitio web está sujeta a cambios en cualquier momento sin previo aviso.',

  info4characters:
    'El campo no puede estar vacío. Se deben ingresar al menos 4 caracteres. No se permiten caracteres especiales...',

  ftext1:
    'Socios-1xBet utiliza cookies para mejorar su experiencia en el sitio web. Al continuar navegando por el sitio web Partners-1xBet, acepta el uso de estas cookies.',
  sportListText: ['Elige tu', 'Deporte favorito', ' Y apuesta ahora!'],
  aviator: 'Aviator',
  downloadApk: 'Descargar APK',
  allRightsReserved: 'Todos los derechos reservados',
}
